import { Form } from '@wearetla/tla-essentials-tools/partials/forms';
import '/assets/styles/partials/forms/form.scss';

export default Form;
